import React from 'react'
import { Outlet } from 'react-router'
import { Container, Box, ThemeProvider, useMediaQuery } from '@mui/material'
import CssBaseline from '@mui/material/CssBaseline'
import { AppProvider } from '@toolpad/core/react-router-dom'

import { ToastContainer } from 'react-toastify'
import theme from 'theme'

function AuthLayout() {
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
  return (
    <AppProvider
      theme={theme}
      colorScheme="light"
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Container
          sx={{
            height: '100vh',
            width: '100%',
            backgroundColor: theme.vars.palette.background.default,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              width: '50%',
              minWidth: '34rem',
              backgroundColor: theme.vars.palette.text.contrast,
              borderRadius: '1.6rem',
              padding: `${isLargeScreen ? '2.4rem' : '2rem'}`,
            }}
          >
            <Outlet></Outlet>
          </Box>
        </Container>

        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </ThemeProvider>
    </AppProvider>
  )
}

export default AuthLayout
